export default __webpack_public_path__ + "static/media/img_baseBunny_rose.c0e0d86e.jpg";